import React from "react";

import useDocTitle from "@/hooks/use-doc-title";
import B2CHeader from "@/tpo/header/B2CHeader";

import Box from "./Box";
import { CustomerAccountPage } from "./CustomerPage";
import Text from "./Text";

function Error404Page() {
  useDocTitle("Page not found");
  return (
    <>
      <B2CHeader />
      <CustomerAccountPage
        jumbotronProps={{
          title: "Page not found"
        }}
      >
        <Box pt={40}>
          <Text>I'm sorry, that page cannot be found</Text>
        </Box>
      </CustomerAccountPage>
    </>
  );
}

export default Error404Page;
